module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD5SURBVHgBlVLLDYJAEN0FCrADSuBgAZhQggWY6J0LV1hg4aolmGAHFKCJJVCAiXZAAXx8o2DIBgK+5GWzs/tmdt4sZ38gTVMXiwALcO/7/ktbKo6iaIWlp9227ZniixIkSXIyDMNFRdk0zRqhknNu0pkxV1XX9SsuW10iOwgCJ45jDy/IKcanxOiXKtxAcxiv63obhmHe70dbkFJaY2I6GopHX4DKOyxH9jVriAM8yNT7XBHTiIRyp4RxjhCiYCP4JSCnYZarnD9Bh+bNJqBNieFyMSf+vKBz+6HEs6qqPIyxZDOgf6D2LOnDsIWgBBvwDuaoellSdYg3hyZd9zY+MWwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/edit-pen.png
// module id = 3217
// module chunks = 0